import { Grid, GridItem, GridProps } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

import { LectureRestriction } from '@/components/ui/features/lecture/LectureHeaderSection/components/LectureRestriction';
import { LectureInfo } from '@/components/ui/features/lecture/LectureInfo/LectureInfo';

interface ILectureVariantsBase extends GridProps {
  children: ReactNode;
}

export const LectureVariantsBase: FC<ILectureVariantsBase> = ({ children, ...rest }) => {
  return (
    <Grid gridTemplateRows="1fr min-content min-content" gridTemplateColumns="1fr min-content" rowGap={4} {...rest}>
      <LectureRestriction>{children}</LectureRestriction>
      <GridItem gridRow="2 / 3" gridColumn="1 / -1">
        <LectureInfo />
      </GridItem>
    </Grid>
  );
};
